import React from 'react';
import PropTypes from 'prop-types';

import {connectAppEnv} from '../../../app/app-env';
import {frefFromRef} from '../../../lib/react/higher-order-components';
import {OEViewType, OEStartViewTypes} from '../../../lib/oe-types';
import {OEFNWelcomeEntryTypes} from '../flow-nav/welcome/oe-fn-welcome-model';
import OENotification from '../../../lib/notification/oe-notification';
import OEStartViewStd from './std/oe-start-view-std';
import OEFNStartView from './oe-flow-nav-start-view';
import OEAmbossStartView from '../../custom/amboss/oe-amboss-start-view';
import OEAnatomyStartView from '../../custom/anatomy/oe-anatomy-start-view';
import OEBayerStartView from '../../custom/bayer/oe-bayer-start-view';
import OEBBraunStartView from '../../custom/bbraun/oe-bbraun-start-view';
import OECellStartView from '../../custom/cell/oe-cell-start-view';
import OEDemoStartView from '../../custom/demo/oe-demo-start-view';
import OEEarStartView from '../../custom/ear/oe-ear-start-view';
import OEEquineHoofStartView from '../../custom/equineHoof/oe-equine-hoof-start-view';
import OEImplantcastStartView from '../../custom/implantcast/oe-implantcast-start-view';
import OEMediCADemyStartView from '../../custom/mediCADemy/oe-medicademy-start-view';
import OEOrthoStartView from '../../custom/ortho/oe-ortho-start-view';
import OESchoolStartView from '../../custom/school/oe-school-start-view';
import OEScienceStartView from '../../custom/science/oe-science-start-view';
import OESkinStartView from '../../custom/skin/oe-skin-start-view';
import OESportStartView from '../../custom/sport/oe-sport-start-view';
import OESurgeryStartView from '../../custom/surgery/oe-surgery-start-view';
import OEThiemeStartView from '../../custom/thieme/oe-thieme-start-view';
import OEToxnetzStartView from '../../custom/toxnetz/oe-toxnetz-start-view';
import OEXRayStartView from '../../custom/xRay/oe-xray-start-view';
import OEFNTestView from '../flow-nav/oe-flow-nav-test-view';
import {OEDefaultConfigFactory} from '../../oe-default-configs';
import OEIconCodes from '../../../lib/oe-icon-codes';
import {OETarget} from '../../../react-oe/oe-target';

export function OEStartViewFactory(props) {
    let {fref, config, helpViewConfig, ...rest} = props;

    const openFn = (sender, isOpen) => {
        if(!props.appComponent || !props.appComponent.uiLayer) return;
        props.appComponent.uiLayer.notificationCenter.post(OENotification.viewOpenStateChanged, {
            type: OEViewType.start,
            isOpen: isOpen,
            sender: sender
        });
    };

    if(config.type === OEStartViewTypes.amboss) {
        return <OEAmbossStartView {...props} onOpenStateChanged={openFn}/>
    } else if(config.type == OEStartViewTypes.anatomy)  {
        return <OEAnatomyStartView {...props} onOpenStateChanged={openFn}/>
    } else if(config.type === OEStartViewTypes.bayer)   {
        return <OEBayerStartView {...props} onOpenStateChanged={openFn}/>
    } else if(config.type === OEStartViewTypes.bbraun)   {
        return <OEBBraunStartView {...props} onOpenStateChanged={openFn}/>
    } else if(config.type === OEStartViewTypes.cell)   {
        return <OECellStartView {...props} onOpenStateChanged={openFn}/>;
    } else if(config.type === OEStartViewTypes.demo)   {
        return <OEDemoStartView {...props} onOpenStateChanged={openFn}/>
    } else if(config.type === OEStartViewTypes.ear)   {
        return <OEEarStartView {...props} onOpenStateChanged={openFn}/>
    } else if(config.type === OEStartViewTypes.equineHoof)   {
        return <OEEquineHoofStartView {...props} onOpenStateChanged={openFn}/>
    } else if(config.type === OEStartViewTypes.implantcast)   {
        return <OEImplantcastStartView {...props} onOpenStateChanged={openFn}/>
    } else if(config.type === OEStartViewTypes.mediCADemy)   {
        return <OEMediCADemyStartView {...props} onOpenStateChanged={openFn}/>
    } else if(config.type === OEStartViewTypes.ortho)   {
        return <OEOrthoStartView {...props} onOpenStateChanged={openFn}/>
    } else if(config.type === OEStartViewTypes.school)   {
        return <OESchoolStartView {...props} onOpenStateChanged={openFn}/>
    } else if(config.type === OEStartViewTypes.science)   {
        return <OEScienceStartView {...props} onOpenStateChanged={openFn}/>
    } else if(config.type === OEStartViewTypes.skin || config.type === OEStartViewTypes.ionto)   {
        return <OESkinStartView {...props} onOpenStateChanged={openFn}/>
    } else if(config.type === OEStartViewTypes.sport)   {
        return <OESportStartView {...props} onOpenStateChanged={openFn}/>
    } else if(config.type === OEStartViewTypes.std) {
        return <OEStartViewStd {...rest} config={config} ref={fref} onOpenStateChanged={openFn}/>;
    } else if(config.type === OEStartViewTypes.surgery)   {
        return <OESurgeryStartView {...props} onOpenStateChanged={openFn}/>
    } else if(config.type === OEStartViewTypes.test)   {
        return <OEFNTestView {...rest} config={config} ref={fref} onOpenStateChanged={openFn}/>;
    } else if(config.type === OEStartViewTypes.thieme)   {
        return <OEThiemeStartView {...props} onOpenStateChanged={openFn}/>
    } else if(config.type == OEStartViewTypes.toxnetz)  {
        return <OEToxnetzStartView {...props} onOpenStateChanged={openFn}/>
    } else if(config.type == OEStartViewTypes.xRay)  {
        return <OEXRayStartView {...props} onOpenStateChanged={openFn}/>
    } else if(config.type === OEStartViewTypes.zeissOpti)   {

        let onClick = (id) => {
            if(!props.appComponent || !props.appComponent.uiLayer || !props.appComponent.app)   return;
            const target = id === 'anatomy' ? OETarget.humanEye2 : (id === 'opti' ? OETarget.zeissOpti2 : OETarget.zeissUV);
            if(props.appComponent.app.changeTarget(target))    {
                props.appComponent.uiLayer.startView.close();
            }
        };

        let entries = [
            {type: OEFNWelcomeEntryTypes.spacer, height: '3.5em' /*56*/},
            {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_text', html: true, minHeight: 81, mask: {licenseValid: true}},
            {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_text_no_license', html: true, minHeight: 81, mask: {licenseValid: false}},
            {type: OEFNWelcomeEntryTypes.spacer, height: '2em' /*32*/},
            {type: OEFNWelcomeEntryTypes.licensing, mask: {licenseValid: false}},
            {type: OEFNWelcomeEntryTypes.menu, id: 'anatomy', stringId: 'target_menu_anatomy', icon: OEIconCodes.zeissOpti.anatomyTarget, onClick: onClick},
            {type: OEFNWelcomeEntryTypes.menu, id: 'opti', stringId: 'target_menu_zeissOpti2', icon: OEIconCodes.zeissOpti.optiTarget, onClick: onClick, logo: 'images/logo_zeiss.png'},
            {type: OEFNWelcomeEntryTypes.menu, id: 'uv', stringId: 'target_menu_zeissUV', icon: OEIconCodes.zeissOpti.UVTarget, onClick: onClick, logo: 'images/logo_zeiss.png'},
            {type: OEFNWelcomeEntryTypes.manual},
            {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20*/},
            {type: OEFNWelcomeEntryTypes.dontShowCheckbox, noSubtitle: true, stringId: 'welcome_view_dont_show_again_title_v2'},
            {type: OEFNWelcomeEntryTypes.spacer, height: '0.5em' /*8*/}
        ];

        return <OEFNStartView {...rest} config={config} entries={entries} ref={fref} onOpenStateChanged={openFn}/>;
    }

    return null;
}

OEStartViewFactory.defaultProps = {
    moduleId: '',
    config: OEDefaultConfigFactory.startView()
};

OEStartViewFactory.propTypes = {
    moduleId: PropTypes.string,
    config: OEDefaultConfigFactory.startViewDecl
};

export default frefFromRef(connectAppEnv((env) => { return {
    version: env.config.version,
    target: env.config.target,
    flags: env.config.module.flags,
    appComponent: env.component,
    config: env.config.module.uiLayerConfig.startView,
    helpViewConfig: env.config.module.uiLayerConfig.helpView
}})(OEStartViewFactory));